$(document).ready(function() {
  const mainPageClassSelector            = ".courses_page.page-container";
  const duplicationClassSelector         = ".course-duplication";
  const sourceApplicationIdSelector      = "#source_application_id";
  const sourceCourseIdSelector           = "#source_course_id";
  const destinationApplicationIdSelector = "#destination_application_id";
  const duplicationWarningsClassSelector = ".duplication-warnings";
  const spinnerClassSelector             = ".spinner";
  const urlForDuplicationWarnings        = "/duplication/course_duplications/warnings.json";

  const retrieveDuplicationWarningsForCourseDuplication = function({ formIdSelector, sourceApplicationId, sourceCourseId, destinationApplicationId }) {
    const payload = {
      source_application_id:      sourceApplicationId,
      source_course_id:           sourceCourseId,
      destination_application_id: destinationApplicationId,
    }

    retrieveDuplicationWarningsForCourseDuplicationPending(formIdSelector);

    $.ajax({
      url:         urlForDuplicationWarnings,
      method:      "POST",
      dataType:    "json",
      contentType: "application/json",
      data:        JSON.stringify(payload),
    }).done(function(response) {
      retrieveDuplicationWarningsForCourseDuplicationCompleted(formIdSelector);

      const duplicationWarningsElement = $(`${mainPageClassSelector} ${formIdSelector} ${duplicationWarningsClassSelector}`);

      if (duplicationWarningsElement) {
        if (response.available) {
          const duplicationWarningsHtml = duplicationWarningsForCourseDuplicationHtml(response);

          if (duplicationWarningsElement) {
            duplicationWarningsElement.html(duplicationWarningsHtml);
            duplicationWarningsElement.show();
          }
        } else {
          duplicationWarningsElement.hide();
        }
      }
    }).fail(function(error) {
      retrieveDuplicationWarningsForCourseDuplicationCompleted(formIdSelector);

      console.error(error);
    });
  }

  const retrieveDuplicationWarningsForCourseDuplicationPending = function(formIdSelector) {
    const duplicationWarningsElement = $(`${mainPageClassSelector} ${formIdSelector} ${duplicationWarningsClassSelector}`);
    const spinnerElement             = $(`${mainPageClassSelector} ${formIdSelector} ${spinnerClassSelector}`);
    const submitElement              = $(`${mainPageClassSelector} ${formIdSelector} input[type="submit"]`);

    if (duplicationWarningsElement) {
      duplicationWarningsElement.hide();
    }

    if (spinnerElement) {
      spinnerElement.show();
    }

    if (submitElement) {
      submitElement.hide();
    }
  }

  const retrieveDuplicationWarningsForCourseDuplicationCompleted = function(formIdSelector) {
    const spinnerElement = $(`${mainPageClassSelector} ${formIdSelector} ${spinnerClassSelector}`);
    const submitElement  = $(`${mainPageClassSelector} ${formIdSelector} input[type="submit"]`);

    if (spinnerElement) {
      spinnerElement.hide();
    }

    if (submitElement) {
      submitElement.show();
    }
  }

  const duplicationWarningsForCourseDuplicationHtml = function(response) {
    const duplicationWarningsHtml = $.map(response.details, function (warningDetail, index) {
      return `
        <dt class="duplication-warning-description">${index + 1}) ${warningDetail.description}</dt>
        <dd class="duplication-warning-message">${warningDetail.message}</dd>
      `;
    }).join("\n");

    return `
      <div class="duplication-warnings-summary">${response.summary}</div>
      <dl>${duplicationWarningsHtml}</dl>
    `;
  }

  $(mainPageClassSelector).on("change", `${duplicationClassSelector} ${destinationApplicationIdSelector}`, function(event) {
    const currentElement = $(this);
    const closestForm    = currentElement.closest('form')[0];

    if (closestForm) {
      const formId                     = closestForm.id;
      const formIdSelector             = `#${formId}`;
      const sourceApplicationIdElement = $(`${formIdSelector} ${sourceApplicationIdSelector}`);
      const sourceCourseIdElement      = $(`${formIdSelector} ${sourceCourseIdSelector}`);

      if (sourceApplicationIdElement && sourceCourseIdElement) {
        const sourceApplicationId      = sourceApplicationIdElement.val();
        const sourceCourseId           = sourceCourseIdElement.val();
        const destinationApplicationId = currentElement.val();

        retrieveDuplicationWarningsForCourseDuplication({ formIdSelector: formIdSelector, sourceApplicationId: sourceApplicationId, sourceCourseId: sourceCourseId, destinationApplicationId: destinationApplicationId });
      }
    }
  });
});
